import React from "react";
import logo from "../assets/logo.png";
import "./BrandLogo.css"; // new CSS file

export default function BrandLogo() {
  return (
    <div className="brand-logo-container">
      <div className="brand" aria-hidden="true">
        <div className="mark">
          <img src={logo} alt="logo" className="brand-logo-img" />
        </div>
        <div className="brand-text">
          <div className="brand-title">Dindori Pranit</div>
          <div className="brand-subtitle">Shree Swami Samarth Seva Marg</div>
          <div className="brand-small">Akhil Bharatiya Shree Swami Samarth Gurupeeth</div>
        </div>
      </div>
    </div>
  );
}
